import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import { formatActDate, formatCourtDate } from "@/Utils/litigationDates.mjs";

import { api_without_cancellation } from "../../../api/api";
// import incidentIcon from "../../../assets/images/incident.svg";
// import birthdayIcon from "../../../assets/images/birthdayicon.svg";
// import { calculateAge, formatDateForPanelDisplay } from "../../../Utils/helper";
// import UserChatBubble from "../../Forms/FirmUserBtn";
import TableLoader from "../../Loaders/tableLoader";

const FirmReportingLitigation = ({ mainRef, controlRef, template, setReportData }) => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const _userOnlineStatus = useSelector((state) => state.chat2.userOnlineStatus);

  const [availableRows, setAvailableRows] = useState(0);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (!mainRef?.current || !controlRef?.current) return;

    const totalHeight = mainRef.current.getBoundingClientRect().height;
    const controlHeight = controlRef.current.getBoundingClientRect().height;
    const availableheight = totalHeight - controlHeight;
    const height = availableheight - 25;

    const rowsFromHeight = Math.floor(height / 25);
    const rowsToSubtract = data?.data?.length ?? 0;

    setAvailableRows(Math.max(0, rowsFromHeight - rowsToSubtract));
  }, [mainRef, controlRef, data]);

  const fetchTemplates = async () => {
    try {
      setLoading(true);
      const res = await api_without_cancellation.get(
        `/api/firm-reporting/firm-reporting-litigation/?template_id=${template?.id}`
      );

      const data = await res.data;
      setData(data);
      setReportData(data?.data);
    } catch (error) {
      console.error("Error fetching templates:", error);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (template) {
      fetchTemplates();
    } else {
      setData([]);
      setReportData([]);
    }
  }, [template]);

  return (
    <>
      <div
        style={{
          overflowX: "auto",
          overflowY: "hidden",
          width: "100%",
          scrollbarWidth: "none",
        }}
        className="m-b-5 table--no-card invisible-scrollbar rounded-0 border-0 w-100 firm-reporting-table-container"
        ref={tableRef}
      >
        <table
          style={{
            overflowX: "scroll",
          }}
          className="table table-borderless settlement-table"
        >
          <thead>
            <tr
              id="report-tb-header"
              className="settle-t-4 height-25 cursor-default"
              style={{
                background: "var(--primary-10)",
                color: "var(--primary)",
              }}
            >
              <th
                className=""
                style={{
                  width: "35px",
                  minWidth: "35px",
                  maxWidth: "35px",
                  color: "var(--primary-25)",
                }}
              />

              {template && (
                <>
                  {" "}
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Details
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}
              {/* Dynamic columns based on selected report values */}
              {template?.screen_by_stage && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Stage
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.screen_by_status && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Status
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.has_issues && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Case Has Issues
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.is_flagged && (
                <>
                  <th
                    className="text-start td-autosize"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      height: "25px",
                    }}
                  >
                    Case Is Flagged
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.court_name && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Court Name
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              {template?.trial_date && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Trial Date
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}
              {template?.filing_date && (
                <>
                  <th className="td-autosize ">
                    <div className="d-flex align-items-center justify-content-center w-100 height-25">
                      Filing Date
                    </div>
                  </th>
                  <th className="spacer-column" />
                </>
              )}

              <th
                className=""
                style={{
                  width: "15px",
                  minWidth: "15px",
                  maxWidth: "15px",
                }}
              />
            </tr>
          </thead>
          <tbody id="body-table mb-1" className="table-firm-reporting">
            {loading && <TableLoader />}
            {!loading &&
              data?.data?.map((reporting, idx) => {
                return (
                  <>
                    <tr key={reporting?.id} className="cursor-default height-25">
                      <td
                        className="text-center"
                        style={{ width: "35px", color: "var(--primary-25)" }}
                      >
                        {idx + 1}
                      </td>
                      <td className="text-start">
                        <div
                          className="d-flex align-items-center"
                          style={{
                            gap: "5px",
                            width: "max-content",
                          }}
                        >
                          <span>{reporting?.case?.for_client?.first_name}</span>
                          <span>{reporting?.case?.for_client?.last_name}</span>
                          <img
                            className="ic ic-15"
                            src={reporting?.case?.case_type?.casetype_icon}
                          />
                          <span>{reporting?.case?.case_type?.name}</span>
                        </div>
                      </td>
                      <td />
                      {/*  */}
                      {template?.screen_by_stage && (
                        <>
                          <td className="text-start">
                            {
                              reporting?.case?.auto_case_stage[
                                reporting?.case?.auto_case_stage?.length - 1
                              ]?.name
                            }
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.screen_by_status && (
                        <>
                          <td className="text-start">
                            <div
                              className="d-flex align-items-center"
                              style={{
                                flexWrap: "wrap",
                                gap: "5px",
                              }}
                            >
                              {reporting?.case?.auto_case_status?.map((status) => {
                                return (
                                  <>
                                    <span>{status?.name}</span>
                                  </>
                                );
                              })}
                            </div>
                          </td>
                          <td className="" />
                        </>
                      )}

                      {template?.has_issues && (
                        <>
                          <td className="text-start">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.is_flagged && (
                        <>
                          <td className="text-start">{/*  */}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.court_name && (
                        <>
                          <td className="text-start">{reporting?.litigation?.court_name}</td>
                          <td className="" />
                        </>
                      )}

                      {template?.trial_date && (
                        <>
                          <td className="text-start">
                            {reporting?.litigation_acts
                              ?.filter(
                                (lit) => lit?.event_type_id?.litigation_event_type === "Trial"
                              )
                              ?.map((lit) => (
                                <>
                                  {lit?.start_date && formatActDate(lit, "start_date")}
                                  {lit?.end_date && formatActDate(lit, "end_date")}
                                </>
                              ))}
                          </td>
                          <td className="" />
                        </>
                      )}
                      {template?.filing_date && (
                        <>
                          <td className="text-start">
                            {formatCourtDate(reporting?.litigation?.filing_date)}
                          </td>
                          <td className="" />
                        </>
                      )}

                      <td />
                    </tr>
                  </>
                );
              })}
            {Array.from({ length: Math.max(0, availableRows || 0) }).map((_, index) => (
              <tr key={`fake-row-${index}`} style={{ height: "25px" }}>
                <td colSpan={18}>&nbsp;</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default FirmReportingLitigation;
